import {
  TextField,
  Box,
  Typography,
  FormControl,
  FormLabel,
  Button,
  IconButton,
  FormControlLabel,
  Tooltip,
  Checkbox,
  LinearProgress,
  Breadcrumbs,
  MenuItem,
  Select,
  InputLabel,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
} from "@mui/material";
import ArrowDownwardIcon from "@mui/icons-material/ArrowDownward";

import OpenInNewIcon from "@mui/icons-material/OpenInNew";
import store from "../../..";
import {
  dataGridHeaderFooterHeight,
  dataGridHeight,
  dataGridPageSize,
  dataGridPageSizeOption,
  dataGridRowHeight,
} from "../../../ui-components/global/utils";
import SaveIcon from "@mui/icons-material/Save";
import CancelIcon from "@mui/icons-material/Cancel";
import AddIcon from "@mui/icons-material/Add";
import EditIcon from "@mui/icons-material/Edit";
import DeleteIcon from "@mui/icons-material/Delete";
import axios from "axios";
import {
  GridActionsCellItem,
  DataGrid,
  GridRowModes,
  GridToolbarContainer,
  GridRowEditStopReasons,
} from "@mui/x-data-grid";
import NavigateNextIcon from "@mui/icons-material/NavigateNext";
import useMediaQuery from "@mui/material/useMediaQuery";
import LogoutOutlinedIcon from "@mui/icons-material/LogoutOutlined";
import ResetTvIcon from "@mui/icons-material/ResetTv";
import { Field, Formik } from "formik";
import { CheckBox } from "@mui/icons-material";
import { useParams, useNavigate, useLocation } from "react-router-dom";

import { gradeSchema } from "../../Security/validation";
import { useDispatch, useSelector } from "react-redux";
import { toast } from "react-hot-toast";
import {
  fetchApidata,
  getFetchData,
  postApidata,
  postData,
} from "../../../store/reducers/Formapireducer";
import React, { useState, useEffect, useRef } from "react";
import { LoadingButton } from "@mui/lab";
import Swal from "sweetalert2";
import { useProSidebar } from "react-pro-sidebar";
import MenuOutlinedIcon from "@mui/icons-material/MenuOutlined";
import { useTheme } from "@mui/material/styles";
import { tokens } from "../../../Theme"; // Adjust the path based on your project structure
import { ArrowDropDownIcon } from "@mui/x-date-pickers";
import {
  Productautocomplete,
  SprintEmpAutocomplete,
} from "../../../ui-components/global/Autocomplete";
import {
  fetchExplorelitview,
  getTaskDetailListviewData,
} from "../../../store/reducers/Explorelitviewapireducer";
import { formGap } from "../../../ui-components/global/utils";
import FileUploadIconButton from "../../../ui-components/FileUploadButton";
import { attachmentPost } from "../../../store/reducers/LoginReducer";
import { nanoid } from "@reduxjs/toolkit";
import DeleteForeverIcon from "@mui/icons-material/DeleteForever";
// import CryptoJS from "crypto-js";
// import ErrorMsgData from "../../Security/validationMsg.json"
import * as Yup from "yup";

const Edittask = () => {
  const isNonMobile = useMediaQuery("(min-width:600px)");
  const navigate = useNavigate();
  let params = useParams();
  const dispatch = useDispatch();
  var recID = params.id;
  var mode = params.Mode;
  var accessID = params.accessID;
  const EMPID = sessionStorage.getItem("EmpId");
  const data = useSelector((state) => state.formApi.Data) || {};
  const Status = useSelector((state) => state.formApi.Status);
  const Msg = useSelector((state) => state.formApi.msg);
  const isLoading = useSelector((state) => state.formApi.postLoading);
  const getLoading = useSelector((state) => state.formApi.getLoading);
  const listViewurl = useSelector((state) => state.globalurl.listViewurl);
  const CompanyAutoCode = sessionStorage.getItem("CompanyAutoCode");
  console.log(CompanyAutoCode, "CompanyAutoCode");
  const YearFlag = sessionStorage.getItem("YearFlag");
  const Year = sessionStorage.getItem("year");
  const Finyear = sessionStorage.getItem("YearRecorid");
  const CompanyID = sessionStorage.getItem("companyId");
  const { toggleSidebar, broken, rtl } = useProSidebar();
  const location = useLocation();
  var OPRecid = params.filtertype;
  const exploreLoading = useSelector((state) => state.exploreApi.loading);
  const theme = useTheme();
  const colors = tokens(theme.palette.mode);
  const state = location.state || {};
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");
  const rowSx = { height: 36, "& td, & th": { py: 0.5 } };
  const [files, setFiles] = useState([]);
  const [showImage, setShowImage] = useState(mode == "IM" ? true : false);
  const [page, setPage] = React.useState(0);
  const [pageSize, setPageSize] = useState(15);
  const [errorMsgData, setErrorMsgData] = useState(null);
  const [validationSchema, setValidationSchema] = useState(null);

  useEffect(() => {
    fetch(process.env.PUBLIC_URL + "/validationcms.json")
      .then((res) => {
        if (!res.ok) throw new Error("Failed to fetch validationcms.json");
        return res.json();
      })
      .then((data) => {
        setErrorMsgData(data);

        let schemaFields = {
          name: Yup.string().trim().required(data.Milestone.name),
        };

        if (CompanyAutoCode === "N") {
          schemaFields.code = Yup.string().required(data.Milestone.code);
        }

        const schema = Yup.object().shape(schemaFields);
        setValidationSchema(schema);
      })
      .catch((err) => console.error("Error loading validationcms.json:", err));
  }, [CompanyAutoCode]);
  useEffect(() => {
    dispatch(getFetchData({ accessID, get: "get", recID })).then((res) => {
      console.log(res, "response");
      var url = store.getState().globalurl.empGetAttachmentUrl;

      axios
        .get(url, {
          params: {
            empId: EMPID,
            appId: recID,
          },
        })
        .then((response) => {
          setFiles(response.data);
        })
        .catch((err) => {
          setError("Failed to fetch attachments.");
          console.error(err);
        })
        .finally(() => setLoading(false));
    });
  }, [location.key]);

  const InitialValue = {
    code: data.Code,
    name: data.Name,
    sortorder: data.SortOrder,
    disable: data.Disable === "Y" ? true : false,
  };

  const [show, setScreen] = React.useState("0");

  const Fnsave = async (values, del) => {
    let action =
      mode === "A" && !del
        ? "insert"
        : mode === "E" && del
        ? "harddelete"
        : "update";
    var isCheck = "N";
    if (values.disable == true) {
      isCheck = "Y";
    }

    const idata = {
      RecordID: recID,
      Code: values.code,
      Name: values.name,
      SortOrder: values.sortorder || 0,
      Disable: isCheck,
      ActivitesID: OPRecid,
      CompanyID,
    };

    const response = await dispatch(postData({ accessID, action, idata }));
    if (response.payload.Status == "Y") {
      toast.success(response.payload.Msg);
      //navigate(`/Apps/Secondarylistview/TR235/Task/${OPRecid}`);
      navigate(-1);
    } else {
      toast.error(response.payload.Msg);
    }
  };

  const screenChange = async (event) => {
    setScreen(event.target.value);
    if (event.target.value == "1") {
      const data = await dispatch(
        getTaskDetailListviewData({
          accessID: "TR237",
          screenName: "Task Detail",
          filter: `TaskID = ${recID}`,
          any: "",
          CompID: "",
        })
      );
      console.log("🚀 ~ screenChange ~ data:", data);
      if (data.payload.Status == "Y") {
        const resData = data.payload.Data.rows.map((value) => {
          return {
            ...value,
            TaskDetailRoleID: {
              RecordID: value.TaskDetailRoleID,
              Name: value.RoleName,
            },
          };
        });
        setRows(resData);
      } else {
        setRows([]); // Ensures rows don't break if explorelistViewData is undefined or not an array
      }
    }
  };

  const [rows, setRows] = React.useState([]);
  const [rowModesModel, setRowModesModel] = React.useState({});

  const handleRowEditStop = (params, event) => {
    if (params.reason === GridRowEditStopReasons.rowFocusOut) {
      event.defaultMuiPrevented = true;
    }
  };

  const handleEditClick = (RecordID) => () => {
    setRowModesModel({
      ...rowModesModel,
      [RecordID]: { mode: GridRowModes.Edit },
    });
  };

  const handleSaveClick = (RecordID) => () => {
    setRowModesModel({
      ...rowModesModel,
      [RecordID]: { mode: GridRowModes.View },
    });
  };

  const handleDeleteClick = (RecordID) => async () => {
    setRows(rows.filter((row) => row.RecordID !== RecordID));
console.log();

    if (!isNaN(RecordID)) {
      const idata = {
        //RecordID: recID,
        RecordID: RecordID,
      };

      const response = await dispatch(
        postData({
          accessID: "TR237",
          action: "harddelete",
          idata: idata,
        })
      );

      if (response.payload?.Status === "Y") {
        toast.success(response.payload.Msg);
        const data = await dispatch(
          getTaskDetailListviewData({
            accessID: "TR237",
            screenName: "Task Detail",
            filter: `TaskID = ${recID}`,
            any: "",
            CompID: "",
          })
        );
        console.log("🚀 ~ screenChange ~ data:", data);
        if (data.payload.Status == "Y") {
          const resData = data.payload.Data.rows.map((value) => {
            return {
              ...value,
              TaskDetailRoleID: {
                RecordID: value.TaskDetailRoleID,
                Name: value.RoleName,
              },
            };
          });
          setRows(resData);
        } else {
          setRows([]); // Ensures rows don't break if explorelistViewData is undefined or not an array
        }
      } else {
        toast.error(response.payload?.Msg || "Operation failed");
      }
    }
  };

  const handleCancelClick = (RecordID) => () => {
    setRowModesModel({
      ...rowModesModel,
      [RecordID]: { mode: GridRowModes.View, ignoreModifications: true },
    });

    const editedRow = rows.find((row) => row.RecordID === RecordID);
    if (editedRow.isNew) {
      setRows(rows.filter((row) => row.RecordID !== RecordID));
    }
  };

  const processRowUpdate = (newRow, oldRow) => {
    const {
      TaskDetailRoleID,
      TaskDetailEffort,
      TaskDetailUnit,
      ProjectPlanedDate,
    } = newRow;

    // Validation rules
    if (!TaskDetailRoleID) {
      throw new Error("Role ID is required.");
    }

    if (!TaskDetailUnit || TaskDetailUnit.trim() === "") {
      throw new Error("Unit is required.");
    }

    if (!ProjectPlanedDate || ProjectPlanedDate.trim() === "") {
      throw new Error("Planned Date is required.");
    }

    if (isNaN(TaskDetailEffort) || TaskDetailEffort <= 0) {
      throw new Error("Effort must be a number greater than 0.");
    }

    // If all validations pass
    const updatedRow = { ...newRow, isNew: false };

    setRows((prevRows) =>
      prevRows.map((row) =>
        row.RecordID === newRow.RecordID ? updatedRow : row
      )
    );

    return updatedRow;
  };
  const handleRowModesModelChange = (newRowModesModel) => {
    setRowModesModel(newRowModesModel);
  };

  function EditDateCell(props) {
    const { id, field, value, api } = props;

    const handleChange = (event) => {
      const newValue = event.target.value;
      api.setEditCellValue({ id, field, value: newValue });
    };

    return (
      <TextField
        type="date"
        fullWidth
        size="small"
        value={value ? new Date(value).toISOString().split("T")[0] : ""}
        onChange={handleChange}
        InputLabelProps={{ shrink: true }}
      />
    );
  }

  function EditAutocompleteCell(props) {
    const { id, value, field, api, row } = props;
    console.log("🚀 ~ EditAutocompleteCell ~ id:", id);

    const handleChange = async (newValue) => {
      //   if (!newValue){

      //   } return;

      setRole(newValue);
      await api.setEditCellValue({
        id,
        field: "TaskDetailRoleID",
        value: newValue,
      });

       api.stopCellEditMode({ id, field });
    };
    const [role, setRole] = useState(
      row.TaskDetailRoleID ? row.TaskDetailRoleID : null
    );
    return (
      <SprintEmpAutocomplete
        name="TaskDetailRoleID"
        label="Role Name"
        id="TaskDetailRoleID"
        value={role}
        onChange={handleChange}
        url={`${listViewurl}?data={"Query":{"AccessID":"2047","ScreenName":"Role","Filter":"parentID=${CompanyID}","Any":""}}`}
      />
    );
  }

  function formatDateToDDMMYYYY(dateStr) {
    if (!dateStr) return "";

    const [year, month, day] = dateStr.split("-");
    if (!year || !month || !day) return "";

    return `${day}-${month}-${year}`;
  }

  const handleInsertInrow = (recordID) => {
    const newId = nanoid(); // Temporary unique ID

    setRows((prevRows) => {
      const index = prevRows.findIndex((row) => row.RecordID === recordID); // ✅ Find the clicked row's index

      if (index === -1) return prevRows; // If not found, return unchanged rows

      const nextSLNO =
        rows.length > 0 ? Math.max(...rows.map((row) => row.SLNO || 0)) + 1 : 1;

      const newRow = {
        RecordID: newId, // Temporary ID, replaced after backend save
        SLNO: nextSLNO,
        TaskID: "",
        TaskDetailRoleID: null,
        RoleCode: "",
        RoleName: "",
        TaskDetailEffort: 0,
        TaskDetailUnit: "",
        ProjectPlanedDate: "",
        isNew: true,
      };

      const updatedRows = [...prevRows];
      updatedRows.splice(index + 1, 0, newRow); // ✅ Insert row at the correct position

      return updatedRows;
    });

    console.log("----step3 setRowModesModel initializing Objects");
    setRowModesModel((prev) => ({
      ...prev,
      [newId]: { mode: GridRowModes.Edit },
    }));
  };

  const columns = [
    // { field: "SLNO", headerName: "Sl No", width: 70 },
    // {
    //   field: "slno",
    //   headerName: "SL#",
    //   width: 50,
    //   sortable: false,
    //   filterable: false,
    //   valueGetter: (params) =>
    //     `${params.api.getRowIndexRelativeToVisibleRows(params.id) + 1}`,
    // },
    {
      field: "slno",
      headerName: "SL#",
      width: 60,
      sortable: false,
      filterable: false,
      disableColumnMenu: true,
      valueGetter: (params) => {
        const index = params.api.getRowIndexRelativeToVisibleRows(params.id);

        const totalVisibleRows = params.api.getAllRowIds().length;
        const totalAllRows = params.api.getRowsCount();

        if (totalVisibleRows < totalAllRows) {
          return index + 1;
        } else {
          return page * pageSize + index + 1;
        }
      },
    },
    {
      headerName: "RecordID",
      field: "RecordID",
      width: 100,
      align: "left",
      headerAlign: "center",
      hide: true,
    },

    {
      headerName: (
        <span>
          Role <span style={{ color: "red" }}>*</span>
        </span>
      ),
      field: "TaskDetailRoleID",
      width: 300,
      headerAlign: "center",
      hide: false,
      editable: true,
      sortable: false,
      renderCell: (params) => {
        return params.value?.Name || ""; // show only the name
      },
      renderEditCell: (params) => {
        return <EditAutocompleteCell {...params} />;
      },
    },
    {
      field: "TaskDetailEffort",
      headerName: "Effort",
      width: 100,
      editable: true,
      type: "number",
    },
    {
      field: "TaskDetailUnit",
      headerName: "Unit",
      width: 150,
      align: "left",
      headerAlign: "center",
      editable: true,
      type: "singleSelect",
      valueOptions: ["Hours", "Days", "Month"],
    },
    {
      headerName: "Project Plan date",
      field: "ProjectPlanedDate",
      width: 150,
      hide: false,
      editable: true,
      renderCell: (params) => {
        return formatDateToDDMMYYYY(params.value); // show only the name
      },
      renderEditCell: (params) => {
        return <EditDateCell {...params} />;
      },
    },

    {
      field: "actions",
      type: "actions",
      headerName: "Actions",
      width: 150,
      cellClassName: "actions",
      getActions: ({ id }) => {
        const isInEditMode = rowModesModel[id]?.mode === GridRowModes.Edit;

        if (isInEditMode) {
          return [
            <GridActionsCellItem
              icon={<SaveIcon />}
              label="Save"
              material={{
                sx: {
                  color: "primary.main",
                },
              }}
              onClick={handleSaveClick(id)}
            />,
            <GridActionsCellItem
              icon={<CancelIcon />}
              label="Cancel"
              className="textPrimary"
              onClick={handleCancelClick(id)}
              color="inherit"
            />,
          ];
        }

        return [
          <GridActionsCellItem
            icon={<AddIcon style={{ color: "#00563B" }} />}
            label="Add"
            onClick={() => handleInsertInrow(id)}
            color="inherit"
          />,
          <GridActionsCellItem
            icon={<EditIcon />}
            label="Edit"
            className="textPrimary"
            onClick={handleEditClick(id)}
            color="inherit"
          />,
          <GridActionsCellItem
            icon={<DeleteIcon />}
            label="Delete"
            onClick={handleDeleteClick(id)}
            color="inherit"
          />,
        ];
      },
    },
  ];

  const handleSaveButtonClick = async (action) => {
    const idata = rows.map((row, index) => {
      return {
        RecordID: row.RecordID,
        TaskID: recID,
        RoleID: row.TaskDetailRoleID?.RecordID,
        Effort: row.TaskDetailEffort,
        Unit: row.TaskDetailUnit,
        ProjectPlanedDate: row.ProjectPlanedDate,
        CompanyID,
      };
    });

    try {
      const response = await dispatch(
        postData({
          accessID: "TR237",
          action: "update",
          idata: idata,
        })
      );

      // Check response status for success
      if (response.payload.Status === "Y") {
        toast.success(response.payload.Msg);
        const data = await dispatch(
          getTaskDetailListviewData({
            accessID: "TR237",
            screenName: "Task Detail",
            filter: `TaskID = ${recID}`,
            any: "",
            CompID: "",
          })
        );
        console.log("🚀 ~ screenChange ~ data:", data);
        if (data.payload.Status == "Y") {
          const resData = data.payload.Data.rows.map((value) => {
            return {
              ...value,
              TaskDetailRoleID: {
                RecordID: value.TaskDetailRoleID,
                Name: value.RoleName,
              },
            };
          });
          setRows(resData);
        } else {
          setRows([]); // Ensures rows don't break if explorelistViewData is undefined or not an array
        }
      } else {
        toast.error(response.payload.Msg);
      }
    } catch (error) {
      toast.error("Error occurred during save.");
    }
  };

  function EditToolbar(props) {
    const { setRows, setRowModesModel } = props;

    const handleClick = () => {
      const id = nanoid();
      const nextSLNO =
        rows.length > 0 ? Math.max(...rows.map((row) => row.SLNO || 0)) + 1 : 1;
      setRows((oldRows) => [
        ...oldRows,
        {
          RecordID: id, // Temporary ID, replaced after backend save
          SLNO: nextSLNO,
          TaskID: "",
          TaskDetailRoleID: "",
          RoleCode: "",
          RoleName: "",
          TaskDetailEffort: 0,
          TaskDetailUnit: "",
          ProjectPlanedDate: "",
          isNew: true,
        },
      ]);
      setRowModesModel((oldModel) => ({
        ...oldModel,
        [id]: { mode: GridRowModes.Edit, fieldToFocus: "TaskDetailRoleID" },
      }));
    };
    return (
      <GridToolbarContainer
        sx={{
          marginBottom: "10px",
          display: "flex",
          justifyContent: "flex-start",
        }}
      >
        <Button color="primary" startIcon={<AddIcon />} onClick={handleClick}>
          Add Record
        </Button>
      </GridToolbarContainer>
    );
  }

  const fnLogOut = (props) => {
    Swal.fire({
      title: errorMsgData.Warningmsg[props],
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: props,
    }).then((result) => {
      if (result.isConfirmed) {
        if (props === "Logout") {
          navigate("/");
        }
        if (props === "Close") {
          navigate(`/Apps/Secondarylistview/TR235/Task/${OPRecid}`);
        }
      } else {
        return;
      }
    });
  };
  async function fileUpload(file, EMPID, action, id, purpose) {
    console.log("🚀 ~ fileUpload ~ file:", file);
    const formData = new FormData();
    formData.append("file", file);
    formData.append("empId", EMPID);
    formData.append("appId", data.RecordID);
    formData.append("type", "DT");
    formData.append("source", "Self");
    formData.append("action", action);
    formData.append("id", id);
    formData.append("purpose", purpose);
    const respose = await dispatch(attachmentPost({ data: formData }));

    if (respose.payload.success) {
      toast.success(respose.payload.message);
      //setShowtable(true);
      var url = store.getState().globalurl.empGetAttachmentUrl;
      axios
        .get(url, {
          params: {
            empId: EMPID,
            appId: data.RecordID,
          },
        })
        .then((response) => {
          setFiles(response.data);
        })
        .catch((err) => {
          setError("Failed to fetch attachments.");
          console.error(err);
        })
        .finally(() => setLoading(false));
    } else {
      toast.success(respose.payload.message);
    }
  }

  return (
    <React.Fragment>
      {getLoading ? <LinearProgress /> : false}
      <Paper elevation={3} sx={{ margin: "0px 10px", background: "#F2F0F0", height:"50px"}}>
        <Box
          display="flex"
          justifyContent="space-between"
         
            >
          <Box display="flex" borderRadius="3px" alignItems="center">
            {broken && !rtl && (
              <IconButton onClick={() => toggleSidebar()}>
                <MenuOutlinedIcon />
              </IconButton>
            )}
            <Breadcrumbs
              maxItems={2}
              aria-label="breadcrumb"
              separator={<NavigateNextIcon sx={{ color: "#0000D1" }} />}
            >
              <Typography
                variant="h5"
                color="#0000D1"
                sx={{ cursor: "default",marginLeft:"10px" }}
                onClick={() => {
                  navigate("/Apps/TR133/Project");
                }}
               >
                {`Project(${state.projectName})`}
              </Typography>

              <Typography
                variant="h5"
                color="#0000D1"
                sx={{ cursor: "default" }}
                onClick={() =>
                  navigate(
                    `/Apps/Secondarylistview/TR233/Milestones/${state.projectID}`,
                    { state: { ...state } }
                  )
                }
              >
                {`Milestones(${state.MilestoneName})`}
              </Typography>
              <Typography
                variant="h5"
                color="#0000D1"
                sx={{ cursor: "default" }}
                onClick={() =>
                  navigate(
                    `/Apps/Secondarylistview/TR236/Stages/${state.MilestoneID}`,
                    { state: { ...state } }
                  )
                }
              >
                {`Stages(${state.stagesName})`}
              </Typography>
              <Typography
                variant="h5"
                color="#0000D1"
                sx={{ cursor: "default" }}
                onClick={() => {
                  navigate(
                    `/Apps/Secondarylistview/TR234/Activities/${state.OperationStageID}`,
                    { state: { ...state } }
                  );
                }}
              >
                {`Activity(${state.Activityname})`}
              </Typography>
              <Typography
                variant="h5"
                color="#0000D1"
                sx={{ cursor: "default" }}
                onClick={() => navigate(-1)}
              >
                {mode === "E" ? `Task(${state.TaskName})` : "Task(New)"}
              </Typography>
              {show == "1" ? (
                <Typography
                  variant="h5"
                  color="#0000D1"
                  sx={{ cursor: "default" }}
                >
                  Task detail
                </Typography>
              ) : (
                false
              )}
            </Breadcrumbs>
          </Box>

          <Box display="flex">
            {mode !== "A" ? (
              <FormControl sx={{ m: 1, minWidth: 120 }} size="small">
                <InputLabel id="demo-select-small">Explore</InputLabel>
                <Select
                  labelId="demo-select-small"
                  id="demo-select-small"
                  value={show}
                  label="Explore"
                  onChange={screenChange}
                >
                  <MenuItem value={0}>Task</MenuItem>
                  <MenuItem value={1}>Task Detail</MenuItem>
                </Select>
              </FormControl>
            ) : (
              false
            )}
            <Tooltip title="Close">
              <IconButton onClick={() => fnLogOut("Close")} color="error">
                <ResetTvIcon />
              </IconButton>
            </Tooltip>
            <Tooltip title="Logout">
              <IconButton color="error" onClick={() => fnLogOut("Logout")}>
                <LogoutOutlinedIcon />
              </IconButton>
            </Tooltip>
          </Box>
        </Box>
      </Paper>
      {show == "0" ? (
        <Paper elevation={3} sx={{ margin: "10px" }}>
          {mode === "IM" && (
            <Box
              display="flex"
              padding={1}
              justifyContent="flex-end"
              mt="2px"
              gridColumn="span 4"
              gap={2}
              marginBottom={-5}
            >
              <IconButton
                onClick={() => setShowImage((prev) => !prev)}
                sx={{ padding: "12px" }}
              >
                <ArrowDownwardIcon
                  sx={{ color: "blue", marginBottom: "8px" }}
                />
              </IconButton>
            </Box>
          )}
          <Formik
            initialValues={InitialValue}
            onSubmit={(values, setSubmitting) => {
              setTimeout(() => {
                Fnsave(values);
              }, 100);
            }}
            validationSchema={validationSchema}
            enableReinitialize={true}
          >
            {({
              errors,
              touched,
              handleBlur,
              handleChange,
              isSubmitting,
              values,
              handleSubmit,
              setFieldValue,
            }) => (
              <form onSubmit={handleSubmit}>
                <Box
                  display="grid"
                  gap={formGap}
                  padding={1}
                  gridTemplateColumns="repeat(2 , minMax(0,1fr))"
                  // gap="30px"
                  sx={{
                    "& > div": {
                      gridColumn: isNonMobile ? undefined : "span 2",
                    },
                  }}
                >
                  {CompanyAutoCode == "Y" ? (
                    <TextField
                      name="code"
                      type="text"
                      id="code"
                      label="Code"
                      placeholder="Auto"
                      variant="standard"
                      focused
                      //required
                      InputProps={{ readOnly: true }}
                      value={values.code}
                      onBlur={handleBlur}
                      onChange={handleChange}
                      error={!!touched.code && !!errors.code}
                      helperText={touched.code && errors.code}
                      // autoFocus
                    />
                  ) : (
                    <TextField
                      name="code"
                      type="text"
                      id="code"
                      label={
                        <>
                          Code
                          <span style={{ color: "red", fontSize: "20px" }}>
                            {" "}
                            *{" "}
                          </span>
                        </>
                      }
                      variant="standard"
                      focused
                      // required
                      value={values.code}
                      onBlur={handleBlur}
                      onChange={handleChange}
                      error={!!touched.code && !!errors.code}
                      helperText={touched.code && errors.code}
                      autoFocus
                    />
                  )}

                  <TextField
                    name="name"
                    type="text"
                    id="name"
                    label={
                      <>
                        Description
                        <span style={{ color: "red", fontSize: "20px" }}>
                          {" "}
                          *{" "}
                        </span>
                      </>
                    }
                    variant="standard"
                    focused
                    value={values.name}
                    onBlur={handleBlur}
                    onChange={handleChange}
                    error={!!touched.name && !!errors.name}
                    helperText={touched.name && errors.name}
                    autoFocus={CompanyAutoCode == "Y"}
                    // required
                  />
                  {!showImage ? (
                    <React.Fragment>
                      <TextField
                        name="sortorder"
                        type="number"
                        id="sortorder"
                        label="Sort Order"
                        variant="standard"
                        focused
                        value={values.sortorder}
                        onBlur={handleBlur}
                        onChange={handleChange}
                        error={!!touched.sortorder && !!errors.sortorder}
                        helperText={touched.sortorder && errors.sortorder}
                        sx={{ background: "" }}
                        InputProps={{
                          inputProps: {
                            style: { textAlign: "right" },
                          },
                        }}
                        onWheel={(e) => e.target.blur()}
                        onInput={(e) => {
                          e.target.value = Math.max(0, parseInt(e.target.value))
                            .toString()
                            .slice(0, 8);
                        }}
                      />
                      <Box>
                        <Field
                          type="checkbox"
                          name="disable"
                          id="disable"
                          onChange={handleChange}
                          onBlur={handleBlur}
                          as={Checkbox}
                          label="Disable"
                        />

                        <FormLabel focused={false}>Disable</FormLabel>
                      </Box>
                    </React.Fragment>
                  ) : (
                    false
                  )}
                </Box>
                <Box display="flex" justifyContent="end" padding={1} gap="20px">
                  {/* {mode === "E" ? (
                    <Box display="flex" alignItems="center" gap={1}>
                      <FileUploadIconButton onFileSelect={fileUpload} />
                    </Box>
                  ) : null} */}
                  {/* {mode === "IM" ? (
                    <Button variant="contained" color="info" onClick={() => setShowImage(prev => !prev)}> {showImage ? 'Show Detail' : 'Hide Detail'}</Button>
                  ) : null}
                  {mode === "IM" ? (
                    <Box display="flex" alignItems="center" gap={1}>
                      <FileUploadIconButton onFileSelect={(file) =>
                        fileUpload(
                          file,
                          EMPID,
                          "upload"
                        )
                      } />
                    </Box>
                  ) : null} */}
                  {mode == "IM" && (
                    <>
                      <TextField
                        name="purpose"
                        type="text"
                        id="purpose"
                        label="Purpose"
                        variant="standard"
                        focused
                        value={values.purpose}
                        onBlur={handleBlur}
                        onChange={handleChange}
                        error={!!touched.purpose && !!errors.purpose}
                        helperText={touched.purpose && errors.purpose}
                        sx={{
                          gridColumn: "span 2",
                          height: "17px",
                          marginBottom: "20px",
                        }}
                        InputLabelProps={{ shrink: true }}
                      />

                      <Box display="flex" alignItems="center" gap={1}>
                        <FileUploadIconButton
                          onFileSelect={(file) => {
                            fileUpload(
                              file,
                              EMPID,
                              "upload",
                              "",
                              values.purpose
                            );
                            setFieldValue("purpose", "");
                          }}
                        />
                      </Box>
                    </>
                  )}
                  <LoadingButton
                    disabled={mode == "IM"}
                    color="secondary"
                    variant="contained"
                    type="submit"
                    loading={isLoading}
                  >
                    Save
                  </LoadingButton>
                  {mode == "E" ? (
                    <Button
                      color="error"
                      disabled={mode == "IM"}
                      variant="contained"
                      onClick={() => {
                        Swal.fire({
                          title: errorMsgData.Warningmsg.Delete,
                          icon: "warning",
                          showCancelButton: true,
                          confirmButtonColor: "#3085d6",
                          cancelButtonColor: "#d33",
                          confirmButtonText: "Confirm",
                        }).then((result) => {
                          if (result.isConfirmed) {
                            Fnsave(values, "harddelete");
                            // navigate(-1);
                          } else {
                            return;
                          }
                        });
                      }}
                    >
                      Delete
                    </Button>
                  ) : null}
                  <Button
                    color="warning"
                    variant="contained"
                    onClick={() => {
                      navigate(-1);
                    }}
                  >
                    Cancel
                  </Button>
                </Box>
              </form>
            )}
          </Formik>
        </Paper>
      ) : (
        false
      )}
      {show === "0" && mode === "IM" && files.length > 0 ? (
        <Box mt={2}>
          <Paper elevation={3} sx={{ padding: 2 }}>
            <TableContainer component={Paper}>
              <Table size="small">
                <TableHead>
                  <TableRow sx={rowSx}>
                    <TableCell width={20}>
                      <strong>SL#</strong>
                    </TableCell>
                    <TableCell>
                      <strong>Uploaded Date</strong>
                    </TableCell>
                    <TableCell>
                      <strong>Filename</strong>
                    </TableCell>
                    <TableCell>
                      <strong>Purpose</strong>
                    </TableCell>
                    <TableCell>
                      <strong>Source</strong>
                    </TableCell>
                    <TableCell>
                      <strong>View</strong>
                    </TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {files.length === 0 ? (
                    <TableRow>
                      <TableCell colSpan={4} align="center">
                        No files uploaded yet.
                      </TableCell>
                    </TableRow>
                  ) : (
                    files.map((file, index) => (
                      <TableRow key={file.id || index} sx={rowSx}>
                        <TableCell>{index + 1}</TableCell>
                        <TableCell>{file.uploadedDate}</TableCell>
                        <TableCell>{file.filename}</TableCell>
                        <TableCell>{file.purpose}</TableCell>
                        <TableCell>{file.source}</TableCell>
                        <TableCell>
                          <Tooltip title="Open File">
                            <IconButton
                              color="primary"
                              component="a"
                              href={file.url}
                              target="_blank"
                              rel="noopener noreferrer"
                              size="small"
                            >
                              <OpenInNewIcon fontSize="small" />
                            </IconButton>
                          </Tooltip>
                          <Tooltip title="delete">
                            <IconButton
                              color="error"
                              onClick={() =>
                                fileUpload(
                                  file.filename,
                                  EMPID,
                                  "delete",
                                  file.id,
                                  file.purpose
                                )
                              }
                              size="small"
                            >
                              <DeleteForeverIcon fontSize="small" />
                            </IconButton>
                          </Tooltip>
                        </TableCell>
                      </TableRow>
                    ))
                  )}
                </TableBody>
              </Table>
            </TableContainer>
          </Paper>
        </Box>
      ) : null}

      {show == "1" ? (
        <Paper elevation={3} sx={{ margin: "10px" }}>
          <Formik
            initialValues={InitialValue}
            onSubmit={(values, setSubmitting) => {
              setTimeout(() => {
                Fnsave(values);
              }, 100);
            }}
            enableReinitialize={true}
          >
            {({
              errors,
              touched,
              handleBlur,
              handleChange,
              isSubmitting,
              values,
              handleSubmit,
            }) => (
              <form onSubmit={handleSubmit}>
                <Box
                  display="grid"
                  gap={formGap}
                  padding={1}
                  gridTemplateColumns="repeat(2 , minMax(0,1fr))"
                  // gap="30px"
                  sx={{
                    "& > div": {
                      gridColumn: isNonMobile ? undefined : "span 2",
                    },
                  }}
                >
                  <TextField
                    name="code"
                    type="text"
                    id="code"
                    label="Code"
                    variant="standard"
                    focused
                    value={values.code}
                    onBlur={handleBlur}
                    onChange={handleChange}
                    error={!!touched.code && !!errors.code}
                    helperText={touched.code && errors.code}
                    readOnly
                  />
                  <TextField
                    name="name"
                    type="text"
                    id="name"
                    label="Description"
                    variant="standard"
                    focused
                    value={values.name}
                    onBlur={handleBlur}
                    onChange={handleChange}
                    error={!!touched.name && !!errors.name}
                    helperText={touched.name && errors.name}
                    autoFocus
                    readOnly
                  />
                </Box>

                <Box m="5px">
                  <Typography variant="h4">Role Based Effort</Typography>
                  <Box
                    m="5px 0 0 0"
                    height={dataGridHeight}
                    sx={{
                      "& .MuiDataGrid-root": {
                        border: "none",
                      },
                      "& .MuiDataGrid-cell": {
                        borderBottom: "none",
                      },
                      "& .name-column--cell": {
                        color: colors.greenAccent[300],
                      },
                      "& .MuiDataGrid-columnHeaders": {
                        backgroundColor: colors.blueAccent[800],
                        borderBottom: "none",
                      },
                      "& .MuiDataGrid-virtualScroller": {
                        backgroundColor: colors.primary[400],
                      },
                      "& .MuiDataGrid-footerContainer": {
                        borderTop: "none",
                        backgroundColor: colors.blueAccent[800],
                      },
                      "& .MuiCheckbox-root": {
                        color: `${colors.greenAccent[200]} !important`,
                      },
                      "& .odd-row": {
                        backgroundColor: "",
                        color: "", // Color for odd rows
                      },
                      "& .even-row": {
                        backgroundColor: "#D3D3D3",
                        color: "", // Color for even rows
                      },
                    }}
                  >
                    <DataGrid
                      sx={{
                        "& .MuiDataGrid-footerContainer": {
                          height: dataGridHeaderFooterHeight,
                          minHeight: dataGridHeaderFooterHeight,
                        },
                      }}
                      rows={rows}
                      columns={columns}
                      loading={exploreLoading}
                      rowModesModel={rowModesModel}
                      getRowId={(row) => row.RecordID}
                      editMode="row"
                      disableRowSelectionOnClick
                      rowHeight={dataGridRowHeight}
                      headerHeight={dataGridHeaderFooterHeight}
                      experimentalFeatures={{ newEditingApi: true }}
                      onRowModesModelChange={handleRowModesModelChange}
                      onRowEditStop={handleRowEditStop}
                      processRowUpdate={processRowUpdate}
                      onProcessRowUpdateError={(error) => {
                        console.error(
                          "Row update validation failed:",
                          error.message
                        );

                        toast.error(error.message);
                      }}
                      components={{
                        Toolbar: EditToolbar,
                      }}
                      componentsProps={{
                        toolbar: { setRows, setRowModesModel },
                      }}
                      rowsPerPageOptions={[5, 10, 20]}
                      getRowClassName={(params) =>
                        params.indexRelativeToCurrentPage % 2 === 0
                          ? "odd-row"
                          : "even-row"
                      }
                      pagination
                      pageSize={pageSize}
                      page={page}
                      onPageSizeChange={(newPageSize) =>
                        setPageSize(newPageSize)
                      }
                      onPageChange={(newPage) => setPage(newPage)}
                    />
                  </Box>
                  <Box
                    display="flex"
                    justifyContent="end"
                    padding={1}
                    gap="20px"
                  >
                    <Button
                      color="secondary"
                      variant="contained"
                      onClick={handleSaveButtonClick}
                    >
                      Save
                    </Button>
                    <Button
                      color="warning"
                      variant="contained"
                      onClick={() => navigate(-1)}
                    >
                      Cancel
                    </Button>
                  </Box>
                </Box>
              </form>
            )}
          </Formik>
        </Paper>
      ) : (
        false
      )}
    </React.Fragment>
  );
};

export default Edittask;
